import Button from '@mui/material/Button';
import viberLogo from '../../../viber-logo.svg';

export default function ViberCallButton({ label = "Viber Call", fullWidth = false, phoneNumber }) {
  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      href={`viber://keypad?number=${encodeURIComponent(phoneNumber)}`} 
      startIcon={<img src={viberLogo} alt="Viber" style={{ width: 28, height: 28 }} />}
      fullWidth={fullWidth}
    >
      {label}
    </Button>
  );
}
